// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Smq3v","Number":"Button_Number__Zee-p","Operator":"Button_Operator__d6fig","Equal":"Button_Equal__uoJtz"};